// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"srOnly_srOnly__5IbbC","srOnlyFocus":"srOnly_srOnlyFocus__eBIv0"};